import React, { useState } from 'react';
import FormGroup from '../../../../components/shared/form-group';
import FormActionsRow from '../../../../components/shared/form-actions-row';
import AccessBoundary from '../../../../components/shared/access-boundary';



const SubscriberEditor = ({ item: subscriber = {}, dictionaries: { companies }, onFormSubmit, isFormSubmitting }) => {
    const [id] = useState(subscriber.id);
    const [companyId, setCompanyId] = useState(subscriber.company && subscriber.company.id);
    const [endpoint, setEndpoint] = useState(subscriber.endpoint);
    const [description, setDescription] = useState(subscriber.description);
    const [isDeactivated, setIsDeactivated] = useState(subscriber.isDeactivated);

    const submit = (e) => {
        e.preventDefault();

        if (isFormSubmitting){
            return;
        }
  
        onFormSubmit({ id, endpoint, description, isDeactivated, companyId }); 
    }
  
    return (      
        <div className="endpoint-editor">
             <form onSubmit={submit}>
                <div className="row">  
                    <div className="col-12 col-md-4 mb-5">  
                        <AccessBoundary roles={['GlobalAdministrator']} content={() => { 
                            return (   
                                <FormGroup 
                                    type="select"
                                    label="subscriberEditor.company"
                                    name="companyId"
                                    value={companyId}
                                    onChange={setCompanyId} 
                                    options={companies.map(({id, title}) => { return { key: id, value: title }; })} />
                            );
                        }} />

                        <FormGroup 
                            type="text"
                            label="subscriberEditor.endpoint"
                            name="endpoint" 
                            value={endpoint} 
                            onChange={setEndpoint} 
                        />

                        <FormGroup 
                            type="text"
                            label="subscriberEditor.description"
                            name="description" 
                            value={description} 
                            onChange={setDescription} 
                        />

                        <FormGroup 
                            type="checkbox"
                            label="subscriberEditor.isDeactivated"
                            name="isDeactivated"
                            value={isDeactivated}
                            onChange={setIsDeactivated}
                        /> 

                        <FormActionsRow 
                            onFormSubmit={submit} 
                            isFormSubmitting={isFormSubmitting}
                            goBackUrl="/subscribers/">
                        </FormActionsRow>                   
                    </div>    
                </div>
            </form>  
        </div>    
    ); 
}

export default SubscriberEditor;  